module.exports = __webpack_public_path__ + "img/filter-type-chest--active.6b3ccb21.svg";